import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';


const useIcontyles = makeStyles({
    iconSVG: {
        width: '2em',
        height: '2em',
        color: '#999999'
    }
});

export default function EquipmentIcon(props) {
    const classes = useIcontyles();
    return (
        <SvgIcon {...props} viewBox="0 0 48 48" className={classes.iconSVG}>
            <title>Icon_Equipment</title>
            <path d="M27.6,15.1h0Zm2.8,10.6V25h-.2c-.4-2.5-.1-7.5.1-10.9,0-.5.1-1,.1-1.4l2.2-.2a8.1,8.1,0,0,1,3,1l-4.3.6c-.9.2-.2,2.1.2,2.8a2.8,2.8,0,0,0,1.3.8l6.5-.8c1.3-.2,1.4-.4,1.6,1.2H41a75.5,75.5,0,0,1,.9,9.8h0v-.2ZM32.7,10a14.9,14.9,0,0,0-3.3.4l-2.3-.2.2-.2a6.3,6.3,0,0,1,2-.7.7.7,0,0,0,.3.3,20.5,20.5,0,0,1,3.3-.1l-.2.5M5.9,42.4h0l10.6,3.8h.1s0,1,1.7,1.6a2.6,2.6,0,0,0,2.7-.4l.5-.3L41.9,34.2v.7h1.2a14.6,14.6,0,0,0,1.5-1.2c.4-.3.5-.8.6-1.6l.7-.4a3.7,3.7,0,0,0-.7-3.5c-.1-4-.5-11.4-1.2-12.8h0A7.6,7.6,0,0,0,42.8,13a2.1,2.1,0,0,0-1.1-.5A21.2,21.2,0,0,0,38.3,11L36.9,9.9h1s.8.1,1-.4.1-.4.1-.4l.4-1.3h0a1.3,1.3,0,0,0,.6-.7L41.6,2c.1-.5-.1-1.4-.5-1.6h-.3A24.3,24.3,0,0,0,36.5,0a34.4,34.4,0,0,0-4.1.2,1.2,1.2,0,0,0-1,.9L29.8,6a.4.4,0,0,1-.1.3h0c-.1.4.5,1.3.9,1.2h.2v.3l-.6.2-.3.3-.8.2h0l-2,.7h-.1a4.8,4.8,0,0,0-1.5,1L13.1,11c-.9.2-.3,1.6.2,2.3a2.1,2.1,0,0,0,1.3.8l10.7-.4h1.1a.5.5,0,0,1,.2.4h0a1.5,1.5,0,0,1,.1.7H27c-.2,1.9-.1,8.1,0,11.2h-.1v1.7h0l-.7.4h.1l-.5.2c-1.2.3-16.9,6.4-22,8.4h0l-1.7.6s-1.2,3.2,2.7,5H5.9V41.3" />
        </SvgIcon >
    );
}